// src/pages/Public/LandingPage/v2/i18n/dossiers.js
//
// Dossier descargable por idioma.
//   ES -> Revi-Doss2-es.pdf (espanol, version 2026-09-24)
//   EN -> Revi-Doss2.pdf (ingles)
//   FR -> Revi-Doss2-fr.pdf (frances, version 2026-09-24)
// Para actualizar un dossier: sustituir el PDF con el MISMO nombre en
// assets/document (el build de CRA le pone hash, asi que no hay cache vieja).

import dossierEs from "../../../../../assets/document/Revi-Doss2-es.pdf";
import dossierEn from "../../../../../assets/document/Revi-Doss2.pdf";
import dossierFr from "../../../../../assets/document/Revi-Doss2-fr.pdf";

export const DOSSIERS = {
  es: dossierEs,
  en: dossierEn,
  fr: dossierFr,
};

// Nombre del archivo al descargar, por idioma.
export const DOSSIER_FILENAMES = {
  es: "REVI_Dossier_ES.pdf",
  en: "REVI_Dossier_EN.pdf",
  fr: "REVI_Dossier_FR.pdf",
};
